import interpolateComponents from '@automattic/interpolate-components';
import React from 'react';

import { Container } from 'components/Container';
import { H1 } from 'components/Heading';
import { Link } from 'components/Link';
import { configValue } from 'utils/config';

type Props = {
  /* error saved to redux by async code */
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: Record<string, any>;
};

export function ErrorSection({ error }: Props) {
  return (
    <>
      <H1>
        {
          /* TRANSLATORS: error page title */
          getText('Something Went Wrong')
        }
      </H1>

      <Container mt={3}>
        {interpolateComponents({
          mixedString:
            /* TRANSLATORS: error page title */
            getText(
              "We're sorry, something went wrong. Please try again and if the problem persists, please {{link}}contact us{{/link}}."
            ),
          components: {
            link: <Link href="/help" />,
          },
        })}
      </Container>
      {configValue('idealist', 'devStackTrace') && error && (
        <Container mt={3} color="scarlet">
          {error.toString()}
          {error.stack}
        </Container>
      )}
    </>
  );
}
